import { BsPeople } from "react-icons/bs";
import { HiOutlineUserGroup } from "react-icons/hi";
import { MdOutlineAssessment } from "react-icons/md";
import { PiExam } from "react-icons/pi";
import { RiFile2Fill } from "react-icons/ri";
import { TbBasketQuestion } from "react-icons/tb";
import { ASSISTANT_PATHS } from "../../../helpers/assistantAccess";
import TeacherSidenavbar from "./teacherSidenavbar";

const assistantNavTabs = [
  {
    mainLabel: "المستخدمين",
    icon: <HiOutlineUserGroup size={24} />,
    children: [
      {
        label: " الطلاب",
        link: ASSISTANT_PATHS.students,
        icon: <BsPeople size={24} />,
      },
      {
        label: "الطلاب المتمييزين",
        link: ASSISTANT_PATHS.topStudents,
        icon: <BsPeople size={24} />,
      },
    ],
  },
  {
    mainLabel: "الامتحانات وبنك الاسئلة",
    icon: <PiExam size={24} />,
    children: [
      {
        label: "بنك الاسئلة",
        link: ASSISTANT_PATHS.questionBank,
        icon: <TbBasketQuestion size={24} />,
      },
      {
        label: "الاختبارات",
        link: ASSISTANT_PATHS.exams,
        icon: <PiExam size={24} />,
      },
    ],
  },
  {
    mainLabel: "التقارير",
    icon: <MdOutlineAssessment size={24} />,
    children: [
      {
        label: " غياب الواجبات",
        link: ASSISTANT_PATHS.homeworkAbsent,
        icon: <RiFile2Fill />,
      },
      {
        label: " حضور الواجبات",
        link: ASSISTANT_PATHS.homeworkAttendance,
        icon: <RiFile2Fill />,
      },
      {
        label: "تقرير مراجعة الواجبات",
        link: ASSISTANT_PATHS.homeworkReview,
        icon: <RiFile2Fill />,
      },
      {
        label: "تقرير الواجبات الشامل",
        link: ASSISTANT_PATHS.homeworkByChapter,
        icon: <RiFile2Fill />,
      },
    ],
  },
];

const AssistantSidenavbar = () => (
  <TeacherSidenavbar navTabs={assistantNavTabs} />
);

export default AssistantSidenavbar;
